import React, { useState } from "react";
import PendingCartList from "./pending-cartlist";
import CustomerWishlist from "./customer-wishlist";
import OrdersRegisterReport from "./sale-report";


const Reports = () => {
  const [activeTab, setActiveTab] = useState("Cart-List");

  return (
    <div style={styles.wrapper}>
      {/* ---------- TABS ---------- */}
      <div style={styles.tabs}>
        {["Cart-List", "WhisList", "Sale-Report"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              ...styles.tabBtn,
              borderBottom:
                activeTab === tab ? "2px solid #005487" : "none",
              color: activeTab === tab ? "#005487" : "#333",
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* ---------- TAB CONTENT ---------- */}

      {/* ✅ Cart List */}
      {activeTab === "Cart-List" && <PendingCartList />}

      {/* ✅ Wishlist */}
      {activeTab === "WhisList" && <CustomerWishlist/>}


      {/* ✅ Sale Report */}
      {activeTab === "Sale-Report" && <OrdersRegisterReport/>}
    </div>
  );
};

export default Reports;

/* ---------- STYLES ---------- */
const styles = {
  wrapper: {
    background: "#fff",
    padding: "15px",
    borderRadius: "6px",
  },

  tabs: {
    display: "flex",
    borderBottom: "1px solid #ddd",
    marginBottom: "15px",
  },

  tabBtn: {
    background: "none",
    border: "none",
    padding: "10px 16px",
    cursor: "pointer",
    fontWeight: 500,
  },

  placeholder: {
    padding: "20px",
    color: "#777",
    fontSize: "14px",
  },
};
